<template>
  <div class="card shadow mb-4">
      <!-- Card Header - Dropdown -->
      <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
        <h6 class="m-0 font-weight-bold text-primary">{{ title }}</h6>
      </div>
      <!-- Card Body -->
      <div class="card-body" :style="'height:'+ bodyHeight">
        <div class="chart-area">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'DashBlock',
  props:{
    title: String,
    bodyHeight: {type: String, default: 'auto'}
  }
}
</script>

<style scoped>

</style>
